export default __webpack_public_path__ + "static/media/1195.9504e970.png";